/** @jsx jsx */
import { jsx, Flex, Box, Image, Text } from 'theme-ui'
import { FC, useEffect, useState } from 'react'
import { Tooltip } from 'react-tooltip'
import { Link } from 'gatsby'
import ImageWrapper from '~/components/image-wrapper'
import { space } from '~/gatsby-plugin-theme-ui'
import { ColorBoxV2 } from '~/componentsV2/colors/colorBox'
import { useTooltip } from '../parameters/color-parameter/color-tooltip'

export enum TooltipImageLayout {
  DEFAULT,
  COVER,
}

type Props = {
  variants: ReadonlyArray<{
    title?: string
    image: string
    imageTip: string
    imageSelector: string
    link: string
    onSale: boolean
    currentlyNotInStock?: boolean
  }>
  visibleVariantsCount?: number
  showButtonMore?: boolean
  tooltipLayout?: TooltipImageLayout
  inStockColorOption?: string // used to set active state
}

const ProductItemVariantsList: FC<Props> = ({
  variants,
  visibleVariantsCount = 0,
  tooltipLayout = TooltipImageLayout.DEFAULT,
  inStockColorOption,
}) => {
  const [isSaleUrl, setIsSaleUrl] = useState(false)
  const restVariantsOnSale = variants.filter(variant => variant.onSale)
  const variantsCount = isSaleUrl ? restVariantsOnSale.length : variants.length
  const restVariantsCount = Math.max(variantsCount - visibleVariantsCount, 0)

  const { Tooltip, createdContent, tooltipId } = useTooltip({ id: 'product-color-swatch' })

  useEffect(() => {
    setIsSaleUrl(window.location.href.indexOf('sale') >= 0)
  }, [])

  return (
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: ['flex-start', 'flex-start'],
        mb: '10px',
      }}
    >
      <Flex
        as="ul"
        sx={{
          m: 0,
          p: 0,
          listStyle: 'none',
          alignItems: 'center',
          flexWrap: ['wrap', null, 'nowrap'],
          gap: [0, 2],
        }}
      >
        {variants.map((variant, index) => {
          return (
            <Box
              as="li"
              key={variant.image}
              sx={{
                p: ['1px', '4px'],
                width: [30, 32],
                height: [30, 32],
                display: ['block', index + 1 > visibleVariantsCount ? 'none' : 'block'],
                ...(!variant.onSale &&
                  isSaleUrl && {
                    display: ['none', 'none', 'none'],
                  }),
              }}
            >
              <Link
                to={variant.link}
                data-tip
                data-tooltip-id={tooltipId}
                data-tooltip-content={createdContent(
                  variant?.title ?? '',
                  variant.imageTip ?? variant.image
                )}
                state={{
                  comesFromSaleCollections: isSaleUrl,
                }}
                style={{ boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)' }}
              >
                <ColorBoxV2
                  value={variant.title || ''}
                  src={variant.image}
                  selectedValue={index === 0 ? variant.title : inStockColorOption}
                  currentlyNotInStock={variant.currentlyNotInStock}
                />
              </Link>
            </Box>
          )
        })}
        {restVariantsCount > 0 && (
          <Box
            as="li"
            sx={{
              color: 'muted',
              fontSize: 4,
              pl: space.sm,
              display: ['none', 'block'],
              whiteSpace: 'nowrap',
            }}
          >
            + {restVariantsCount}
          </Box>
        )}
        <Tooltip />
      </Flex>
    </Flex>
  )
}

export default ProductItemVariantsList
